import { OrgbrainErrorCodes } from '@orgbrain/lib-data';

import { ShareholderRecord } from '../classes/shared';
import { ShareNumbers } from './sharenumber-classes';

export function initNumbersRaw({
  records,
  timeStamp,
  eventRef,
  totalShares = 0,
}: {
  records: Array<ShareholderRecord>;
  timeStamp: any; //number
  eventRef: any; //string
  totalShares?: number;
}): ShareholderRecord[] {
  const ret: ShareholderRecord[] = [];

  for (const record of records) {
    if (!Number.isInteger(record.amount)) {
      throw { code: OrgbrainErrorCodes.SHARE_AMOUNT_MUST_BE_INTEGER };
    }
    const numbers: ShareNumbers = {
      from: totalShares,
      to: totalShares + record.amount,
      timeStamp,
      eventRef,
    };
    const newrecord: ShareholderRecord = { ...record };
    newrecord.numbers = [numbers];
    ret.push(newrecord);
    totalShares += record.amount;
  }

  return ret;
}
